import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Button, ButtonColor, ButtonSize } from 'app/store/models/button.model';
import { UserType } from 'app/store/models/user.model';
import { SessionService } from 'app/store/services/session.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-user-replay-listing',
  templateUrl: './user-replay-listing.component.html',
  styleUrls: ['./user-replay-listing.component.scss'],
})
export class UserReplayListingComponent implements OnInit {
  buttonProperties: Button = {
    color: ButtonColor.BLUE,
    size: ButtonSize.SMALL,
    text: 'Edit',
    style: 'filled',
  };
  

  private readonly destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private readonly sessionService: SessionService,
    private readonly router: Router
  ) {}

  ngOnInit() {
    this.sessionService
      .onReady()
      .pipe(takeUntil(this.destroy$))
      .subscribe(userSession => {
        if(userSession && userSession.user_type === UserType.MASTER && userSession.id !== 1) {
          // remove master users except the main one from the page
          this.router.navigate(['/']);
          return;
        }
      });
  }

  getButtonRoute(type: string) {
    return [`/contents/user_replies/${type}/edit`];
  }
}
